module.exports = __webpack_public_path__ + "static/media/hts_logo.505e23cc.png";